<div>
  <sh-text size="header-2">Highest Value of last 24 hours</sh-text>
  <ng-container *ngIf="isSystemStatusLoading; else showCards">
    <sh-spinner class="image-loader" size="l"></sh-spinner>
  </ng-container>
  <ng-template #showCards>
    <div class="card-container">
      <sh-card
        *ngFor="let coolingStatus of systemStatus"
        [icon]="coolingStatus.icon"
        class="cooling-card"
        style="height: 100px"
      >
        <div class="card-content">
          <div class="label-subtext">
            <div class="card-label">
              <sh-text size="header-2">{{
                coolingStatus.measurementName
              }}</sh-text>
            </div>
            <div class="card-value">
              {{
                coolingStatus.maxMeasurementValue === 0
                  ? '-'
                  : coolingStatus.maxMeasurementValue
              }}
              {{ coolingStatus.measurementUnit }}
            </div>
          </div>

          <div class="card-subtext">
            <sh-text size="title-2" color="secondary"
              >Last updated: {{ coolingStatus.lastUpdatedDateTime }}</sh-text
            >
          </div>
        </div>
      </sh-card>
    </div>
  </ng-template>
</div>
